// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9fbd5bed","22":"70bff519","67":"fd1c6423","112":"c3dd9824","453":"89f2dc07"}[chunkId] + ".chunk.js";
};